// extracted by mini-css-extract-plugin
export var CaseStudyArticle = "CaseStudyArticle-module--CaseStudyArticle--BVYKE";
export var CaseStudyArticle_desc = "CaseStudyArticle-module--CaseStudyArticle_desc--wZ1I4";
export var CaseStudyArticle_title = "CaseStudyArticle-module--CaseStudyArticle_title--UywM5";